import { useCallback } from "react";
import {
  FieldMetadataForTypes as FieldMetadata,
  Issue,
  IssueStandardFieldIds,
  SheetAssociation,
} from "@adsk/acc-issues-types";
import isEmpty from "lodash/isEmpty";

/**
 * Provides a function to check if a field has a present value in an issue.
 */
export const useIsFieldValuePresentInIssue = () => {
  return useCallback(
    (
      field: FieldMetadata,
      issue: Issue,
      sheetAssociation: SheetAssociation | undefined
    ): boolean => {
      const hasValue = (value: any) => !isEmpty(value);

      if (field.id === IssueStandardFieldIds.Placement) {
        return hasValue(sheetAssociation) || hasValue(issue.placements);
      }

      // For roles and companies we only have watcherObjects, so when there's only
      // roles and/or companies watchers is empty
      if (field.id === IssueStandardFieldIds.Watchers) {
        return hasValue(issue.watchers) || hasValue(issue.watcherObjects);
      }

      if (issue.hasOwnProperty(field.id)) {
        return hasValue(issue[field.id as keyof Issue]);
      }

      const customAttribute = issue.customAttributes?.find(
        attr => attr.attributeDefinitionId === field.id
      );
      if (customAttribute) {
        return hasValue(customAttribute.value);
      }

      // Exception: always treat References as populated
      if (field.id === "relationships") return true;
      // Exception: Classify attachments based on attachmentsCount
      if (field.id === "attachments") return issue.attachmentCount > 0;

      return false;
    },
    []
  );
};
